import { ResponsiveMapType, ResponsiveSizingType } from './types'

const defaultClasses: ResponsiveSizingType = {
  sm: 'ds-not-sr-only',
  md: 'md:ds-not-sr-only',
  lg: 'lg:ds-not-sr-only'
}

export const twNotSrOnly: ResponsiveMapType = {
  sm: defaultClasses,
  md: defaultClasses,
  lg: defaultClasses,
  default: defaultClasses
}

export default twNotSrOnly
